module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dsn":"DSN (Data Source Name)","database_name":"Database name"},"fr":{"dsn":"DSN (Data Source Name)","database_name":"Nom de la base de données"}}')
  delete Component.options._Ctor
}
